import { TransferRequestDetailPage } from "@/features/transfer-request/pages/TransferRequestDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/transfer-request/$id/detail")({
  validateSearch: (search: Record<string, unknown>) => ({
    source:
      search.source === "transferRequest" ||
      search.source === "incomingTransferRequest"
        ? search.source
        : "incomingTransferRequest", // default
  }),
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["transfer_request.view_outgoing"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferRequestDetailPage,
});
